import React from 'react';

import Layout from '../components/Layout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'gatsby';

const UeberMichPage = () => (
  <Layout>
    <Header />
    <header className="masthead masthead-sub">
      <div className="container h-100">
        <div className="row h-100 align-items-center justify-content-center text-center">
          <div className="col-lg-8 align-self-baseline">
            <h1 className="text-white font-weight-bold">Über mich</h1>
            <hr className="divider my-4" />
            <p className="text-white-75 font-weight-light mb-4">
              Ricardo Wasescha – gelernter Maler EFZ, seit 2020 selbstständig. Tätig in Savognin und im ganzen Val Surses – mit Erfahrung aus Zürich und Winterthur.
            </p>
          </div>
        </div>
      </div>
    </header>

    <section className="page-section" id="about">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h3 className="mb-4">Da wo alles begann</h3>
            <p className="text-muted">
              Geboren, aufgewachsen und wieder zurückgekehrt in meine Heimat Savognin. 
              Mein Name ist Ricardo Wasescha. Ich bin gelernter Maler EFZ und habe 
              in meiner Arbeit meine Berufung gefunden.
            </p>
            <p className="text-muted">
              Nach meiner Lehre, welche ich bei Rizzi &amp; Söhne in Bivio abgeschlossen 
              hatte, war ich für verschiedene Unternehmen im Raum Zürich und Winterthur 
              tätig und besuchte diverse Weiterbildungen wie zum Beispiel den Kurs zur 
              Schimmelpilzsanierung. Jeweils über den Winter widmete ich mir meiner 
              zweiten Leidenschaft, dem Wintersport. Über 14 Jahre unterrichtete ich 
              die Kunst des Snowboardens bei der Schneesportschule in Savognin.
            </p>

            <div className="about-highlight my-5">
              <div className="row text-center">
                <div className="col-md-4 mb-4 mb-md-0">
                  <div className="about-stat">
                    <span className="about-number">2020</span>
                    <span className="about-label">Selbstständig seit</span>
                  </div>
                </div>
                <div className="col-md-4 mb-4 mb-md-0">
                  <div className="about-stat">
                    <span className="about-number">14+</span>
                    <span className="about-label">Jahre Snowboardschule</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="about-stat">
                    <span className="about-number">EFZ</span>
                    <span className="about-label">Maler Berufsausweis</span>
                  </div>
                </div>
              </div>
            </div>

            <h3 className="mb-4">In die Fussstappen getreten</h3>
            <p className="text-muted">
              <strong>2020</strong> erhielt ich die Möglichkeit von meinem Onkel Piero 
              Wasescha, welcher sich 1985 in Savognin als Maler selbständig gemacht hatte, 
              in seine Fussstapfen zu treten. Damit wurde der Grundstein zur Selbständigkeit 
              und zu meinem Unternehmen Maler Wasescha gelegt.
            </p>
            <p className="text-muted">
              Heute biete ich mein Fachwissen und meine Leidenschaft fürs Handwerk an – 
              von Mal- und Spritzarbeiten über Tapezieren bis hin zu dekorativen Techniken 
              und Fassadensanierungen. Gute Arbeit braucht Sorgfalt, und die bring ich mit.
            </p>

            <div className="text-center mt-5">
              <Link to="/#contact" className="btn btn-primary btn-xl mr-3">
                Kontakt aufnehmen
              </Link>
              <Link to="/" className="btn btn-outline-primary btn-xl">
                Zurück zur Startseite
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </Layout>
);

export default UeberMichPage;